import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import Breadcrumb from '../component/Breadcrumb';

const PageNotFound = () => {
  return (
    <>
        <Breadcrumb title="Page Not Found">
            <Typography variant="subtitle2" color="#8C8C8C" className="link-breadcrumb">Home</Typography>
            <Typography variant="subtitle2" className="link-breadcrumb">404 </Typography>
        </Breadcrumb>
        <Box component="section">
            <Grid className="contentBox">
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={3}>
                    <Typography sx={{pt:12}} variant="h1">Page Not Found!</Typography>
                    <Typography variant="h4">The page you’re looking for doesn’t exist.</Typography>
                    <Typography variant="span">You might have typed the wrong address or the page has moved. In the meantime, try again or click on the below button.</Typography>
                    <Button component={Link} to="/" variant="contained">Dashboard</Button>
                </Box>
            </Grid>
        </Box>
    </>
  )
}

export default PageNotFound